import { BaseStyle, Button, GlobalStyle, HStack, Spinner, Text, VStack, themes } from '@talos/kyoko';
import { ThemeProvider } from 'styled-components';

interface IFrameLoadingProps {
  error?: string;
  onRetry: () => void;
}

export function IFrameLoading({ error, onRetry }: IFrameLoadingProps) {
  // unfortunately we need to wrap the component in a ThemeProvider with default theme because this component is loaded before the usual theme provider (which relies on loading the WL org json config, which happens after auth)
  // this is a temporary solution until we find a better way to handle this
  return (
    <ThemeProvider theme={themes.DarkTheme}>
      <BaseStyle />
      <GlobalStyle />
      <VStack h="100vh" w="100vw" alignItems="center" justifyContent="center" gap="spacing16">
        <VStack alignItems="center" gap="spacing8">
          {!error && <Spinner size={48} />}
          <Text size="fontSizeMd" fontWeight="medium" color="colorTextAttention">
            {error ? 'Error Loading Application' : 'Loading Application...'}
          </Text>
          {error && (
            <Text size="fontSizeSm" color="colorTextSubtle" textAlign="center" maxWidth="400px">
              {error}
            </Text>
          )}
        </VStack>

        {error && onRetry && (
          <HStack gap="spacing8">
            <Button onClick={onRetry}>Retry</Button>
          </HStack>
        )}
      </VStack>
    </ThemeProvider>
  );
}

export default IFrameLoading;
